// Centralized configuration for the frontend
const isDev = (process.env.NODE_ENV || 'development') === 'development'
const DEFAULT_API_BASE = isDev ? 'http://localhost:4000' : 'https://api.srv860130.hstgr.cloud'

const config = {
  // API Base URL - overridable via env; defaults to localhost in dev
  API_BASE: process.env.REACT_APP_API_BASE || DEFAULT_API_BASE,
  
  // Frontend URL - used for redirects and links
  FRONTEND_URL: process.env.REACT_APP_FRONTEND_URL || 'https://app.srv860130.hstgr.cloud',
  
  // Environment
  NODE_ENV: process.env.NODE_ENV || 'development',
  
  // Check if we're in production
  isProduction: () => process.env.NODE_ENV === 'production',
  
  // Get full API URL for a given endpoint
  getApiUrl: (endpoint) => {
    const baseUrl = config.API_BASE.replace(/\/$/, ''); // Remove trailing slash
    const cleanEndpoint = endpoint.replace(/^\//, ''); // Remove leading slash
    return `${baseUrl}/${cleanEndpoint}`;
  }
};

export default config;
